"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("../../../index");

var _TransactionCategoriesModel = _interopRequireDefault(require("./models/TransactionCategoriesModel"));

var _DeleteButton = _interopRequireDefault(require("../../../components/crud/DeleteButton"));

var _BreadcrumbHelper = _interopRequireDefault(require("../../../util/BreadcrumbHelper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var TransactionCategoriesList = /*#__PURE__*/function (_Component) {
  _inherits(TransactionCategoriesList, _Component);

  function TransactionCategoriesList(props) {
    var _this;

    _classCallCheck(this, TransactionCategoriesList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransactionCategoriesList).call(this, props));

    _BreadcrumbHelper["default"].setCrumbs([{
      label: 'Transaction Categories'
    }]);

    return _this;
  }
  /**
   * Render
   *
   * @returns {XML}
   */


  _createClass(TransactionCategoriesList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react["default"].createElement("div", {
        className: "dashboard-management"
      }, _react["default"].createElement("h1", null, _react["default"].createElement("i", {
        className: "fa fa-exchange",
        "aria-hidden": "true"
      }), " Transaction Categories"), _react["default"].createElement(_index.AppTable, {
        title: "Transaction Categories",
        onInit: function onInit(tableComponent) {
          return _this2._tableComponent = tableComponent;
        },
        headerActions: _react["default"].createElement(_reactRouterDom.Link, {
          to: "/transaction-categories/add-new",
          className: "button width-240",
          style: {
            marginRight: '10px'
          }
        }, _react["default"].createElement("i", {
          className: "fa fa-fw fa-plus"
        }), "Add new"),
        filter: [{
          name: 'term',
          type: 'term'
        }],
        model: _TransactionCategoriesModel["default"],
        getColumnActions: function getColumnActions(member, index) {
          return _react["default"].createElement("div", null, _react["default"].createElement(_DeleteButton["default"], {
            onConfirm: function onConfirm() {
              return _this2.onDeleteItem(member.id);
            },
            text: 'Are you sure you wish to delete Transaction Categories "' + member.name + '"?'
          }));
        }
      }));
    }
  }, {
    key: "onDeleteItem",
    value: function onDeleteItem(id) {
      var _this3 = this;

      new _TransactionCategoriesModel["default"]()["delete"](id).then(function () {
        _this3._tableComponent._refresh();
      })["catch"](function () {
        _this3.setState({
          showInfoModal: true
        });
      });
    }
  }]);

  return TransactionCategoriesList;
}(_react.Component); // Inject router


exports["default"] = TransactionCategoriesList;
TransactionCategoriesList.contextTypes = {
  router: _propTypes["default"].object
};